import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {VersionDocumentationComponent} from './version-documentation.component';

@Component({
  selector: 'app-version-docs-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, VersionDocumentationComponent],
  template: `
    <div class="vdd-head">
      <div class="t">
        <h2>Documentation</h2>
        <p>{{ data.solutionName }} · {{ data.versionName }}</p>
      </div>
      <button class="vdd-x" type="button" aria-label="Close" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="vdd-body">
      <app-version-documentation
        [solutionId]="data.solutionId"
        [versionId]="data.versionId"
        [solutionName]="data.solutionName"
        [versionName]="data.versionName"
      ></app-version-documentation>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .vdd-head {
      display: flex; align-items: flex-start; justify-content: space-between;
      padding: 20px 24px 14px; border-bottom: 1px solid #e5e7eb;
    }
    .vdd-head h2 { font-size: 18px; font-weight: 700; margin: 0; }
    .vdd-head p { color: #6b7280; font-size: 13px; margin: 4px 0 0; }
    .vdd-x {
      border: none; background: none; color: #6b7280; cursor: pointer;
      display: flex; padding: 4px;
    }
    .vdd-x:hover { color: #1a1a1a; }
    .vdd-body { padding: 18px 24px 24px; max-height: 70vh; overflow: auto; }
  `],
})
export class VersionDocsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<VersionDocsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      solutionId: string; versionId: string; solutionName?: string; versionName?: string;
    }
  ) {}
}
